import { jsx } from 'react/jsx-runtime';
import { createVersionedContext, createVersionedValueMap } from '@backstage/version-bridge';

const EntityContextMenuContext = createVersionedContext("entity-context-menu-context");
const EntityContextMenuProvider = (props) => {
  const { children, onMenuClose } = props;
  const value = { onMenuClose };
  return /* @__PURE__ */ jsx(
    EntityContextMenuContext.Provider,
    {
      value: createVersionedValueMap({ 1: value }),
      children
    }
  );
};

export { EntityContextMenuProvider };
//# sourceMappingURL=EntityContextMenuContext.esm.js.map
